<div
  class="typography typography-h4 grey-900 typography-medium typography-paragraph"
>
  {{ title }}
</div>
<div class="grid grid-column grid-gutter-20">
  <app-catalog-list-item
    class="grid-item full-width"
    *ngFor="let item of list; trackBy: trackBy"
    [item]="item"
  >
  </app-catalog-list-item>
</div>
